import React from 'react';
import { motion } from 'framer-motion';
import { Award, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import OptimizedImage from '@/components/OptimizedImage';

const credentials = [
{ icon: Award, label: "MAGD", desc: "AGD Mastership", link: "https://agd.org/practice/tools/patient-resources/find-an-agd-dentist/PracticeInfo/?id=0csy%2biH76jQ%3d" },
{ icon: Award, label: "DABOI/ID", desc: "ABOI/ID Diplomate", link: "https://aaid-implant.org/dentist/gjelaj-xhoana/" },
{ icon: Award, label: "DICOI", desc: "ICOI Diplomate", link: "https://icoi.world/" },
{ icon: Award, label: "FAAID", desc: "AAID Fellowship", link: "https://aaid-implant.org/dentist/gjelaj-xhoana/" }];


export default function AboutSection() {
  return (
    <section className="py-12 md:py-20 bg-white overflow-x-clip">
      <div className="container mx-auto px-4 md:px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}>

            <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-600 text-white rounded-full mb-6">
              <Award className="w-4 h-4 text-amber-100" />
              <span className="text-sm font-medium">Board-Certified Implantologist</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-slate-800 mb-4 md:mb-6">
              Meet Dr. Xhoana <span className="font-serif italic text-amber-700">Gjelaj</span>
            </h2>
            <p className="text-sm text-amber-700 font-medium mb-6">DMD, MAGD, DICOI, FAAID, DABOI/ID</p>
            
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              Dr. Xhoana Gjelaj earned her DMD at Nova Southeastern University. Her professional credentials
              include MAGD Mastership, DABOI/ID and DICOI diplomate designations, and FAAID Fellowship.
              Each designation reflects a distinct professional credential.
            </p>

            <p className="text-lg text-slate-600 mb-8 leading-relaxed">Dr. Gjelaj plans the implant and the final teeth together. She reviews your oral health, bite and goals, then explains the options and what each would involve.</p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {credentials.map((cred) =>
              <a key={cred.label} href={cred.link} target={cred.link ? "_blank" : undefined} rel={cred.link ? "noopener noreferrer" : undefined} className={cred.link ? "block text-center hover:opacity-80 transition-opacity" : "text-center"}>
                  <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center mx-auto mb-2">
                    <cred.icon className="w-6 h-6 text-amber-600" />
                  </div>
                  <div className="text-sm font-medium text-slate-800">{cred.label}</div>
                  <div className="text-xs text-slate-500">{cred.desc}</div>
                </a>
              )}
            </div>

            <Link
              to="/meet-the-doctor"
              className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors group"
            >
              Learn More About Dr. Gjelaj
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative">

            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-slate-200/50">
              <OptimizedImage
                src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/697e88817b05b4051a928e3f/fb403896a_IMG_0190.jpg"
                alt="Dr. Xhoana Gjelaj, DMD, MAGD, DICOI, FAAID, DABOI/ID"
                fill
                quality="high"
                objectPosition="top"
                className="w-full h-[260px] sm:h-[360px] md:h-[500px] object-cover object-top"
                sizes="(max-width: 768px) 100vw, 50vw"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>);

}